import React from 'react';
import { translate } from 'react-i18next';

import * as Common from 'common/components';
import ExchangeList from 'exchange/components/list';

const ExchangeListView = ({
  children,
  count = 0,
  filters = {},
  isLoading = false,
  company = {},
  pagination = {},
  permissions = {},
  handleOrderChange = () => {},
  handleFiltersChange = () => {},
  handleLimitChange = () => {},
  handlePageChange = () => {},
  handleSubmit = () => {},
  columnSearch,
  handleToggleSearch = () => {}, // Agregar
  t,
}) => {
  return (
    <Common.Wrapper fluid={true}>
      <ExchangeList.Header companyId={company.id} canAdd={permissions['acl.exchanges.add']} />
      <div className="col-12">
        <Common.Portlet title={t('exchange.exchange_title')} icon={'money'}>
          <ExchangeList.Filters
            handleSubmit={handleSubmit}
            handleToggleSearch={handleToggleSearch} // Agregar
            columnSearch={columnSearch} // Agregar
            handleValueChange={handleFiltersChange}
            values={filters}
          />
          <div className="mb-2" style={{ position: 'relative' }}>
            <ExchangeList.Table
              count={count}
              handleOrderChange={handleOrderChange}
              order={pagination.order}
              orderBy={pagination.orderBy}
            >
              {children}
            </ExchangeList.Table>
            <Common.LoaderOverlay show={isLoading} />
          </div>
          <Common.Pagination
            {...pagination}
            handleLimitChange={handleLimitChange}
            handlePageChange={handlePageChange}
          />
        </Common.Portlet>
      </div>
    </Common.Wrapper>
  );
};

export default translate()(ExchangeListView);



// WEBPACK FOOTER //
// src/modules/secured/modules/exchange/components/ExchangeListView.js